import { render, staticRenderFns } from "./ManageJobTemplates.vue?vue&type=template&id=1cb01dd4"
import script from "./ManageJobTemplates.vue?vue&type=script&lang=js"
export * from "./ManageJobTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports